import { realBricksApi } from "../../utils/axiosInterceptors";

export const getSecondaryOfferingData = async (data, { rejectWithValue }) => {
  const {
    page,
    perPage,
    locationString,
    savedProperty,
    ownProperty,
    dividendPaidProperty,
    propertyTypeString,
    leverageString,
    priceRange,
    sortType,
    marketPlaceSearch,
    onFail = () => {},
  } = data;
  try {
    const response = await realBricksApi.get(
      `/api/v1/properties/secondary?page=${page}&perPage=${perPage}${
        locationString && locationString !== "" ? `&${locationString}` : ""
      }${
        propertyTypeString && propertyTypeString !== ""
          ? `&${propertyTypeString}`
          : ""
      }${leverageString && leverageString !== "" ? `&${leverageString}` : ""}${
        savedProperty ? `&savedProperties=${savedProperty ? "1" : "0"}` : ""
      }${ownProperty ? `&ownedProperties=${ownProperty ? "1" : "0"}` : ""}${
        dividendPaidProperty
          ? `&dividendPayingProperties=${dividendPaidProperty ? "1" : "0"}`
          : ""
      }${
        priceRange && priceRange?.length > 0
          ? `&minSharePrice=${priceRange[0]}`
          : ""
      }${
        priceRange && priceRange?.length > 0
          ? `&maxSharePrice=${priceRange[1]}`
          : ""
      }${sortType && sortType !== "" ? `&sort=${sortType}` : ""}${
        marketPlaceSearch && marketPlaceSearch !== ""
          ? `&search=${marketPlaceSearch}`
          : ""
      }`
    );
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};
